/**
 * @generated SignedSource<<31790b110714057c80991c009c0401eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DashboardPageDeleteMutation$variables = {
  id: string;
};
export type DashboardPageDeleteMutation$data = {
  readonly deleteTask: string;
};
export type DashboardPageDeleteMutation = {
  response: DashboardPageDeleteMutation$data;
  variables: DashboardPageDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteTask",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardPageDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardPageDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f9fd97690b636f23b3695af1c291761f",
    "id": null,
    "metadata": {},
    "name": "DashboardPageDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation DashboardPageDeleteMutation(\n  $id: ID!\n) {\n  deleteTask(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "a9cce79c53b94bf895d3984574377bf5";

export default node;
